import { create } from 'zustand';

type QueriesStore = {
  loading: boolean;
  setLoading: (value: boolean) => void;
};

const useTriggerOrderStore = create<QueriesStore>((set) => ({
  loading: false,

  setLoading: (value) => {
    set((_state) => ({
      loading: value,
    }));
  },
}));

export default useTriggerOrderStore;
